import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Bioinformatics Foundations & Computational Biology Basics",
    description:
      "Introduction to bioinformatics,Scope & real-world impact, DNA RNA proteins & biological databases overview, Role of computation in modern biology, Introduction to genomics proteomics & system biology, Industry applications: drug discovery diagnostics agriculture",
  },
  {
    title: "Molecular Biology & Genetics Essentials",
    description:
      "Structure & function of DNA RNA & proteins, Gene expression transcription & translation, Chromosomes SNPs mutations & genetic variation, DNA replication & repair mechanisms, Connecting molecular data to computational analysis",
  },
  {
    title: "Biological Databases & Information Retrieval",
    description:
      "NCBI GenBank UniProt PDB EMBL basics, Sequence formats (FASTA GenBank), Retrieving genomic & protein data, Understanding annotations & metadata, Hands-on database query practice",
  },
  {
    title: "Sequence Alignment, Analysis & Phylogenetics",
    description:
      "Pairwise sequence alignment (global & local), Multiple sequence alignment (MSA), Algorithms: BLAST Clustal Omega MUSCLE, Phylogenetic tree construction, Evolutionary relationships & comparative genomics",
  },
  {
    title: "Structural Bioinformatics & Protein Modeling",
    description:
      "Protein structure levels: primary → quaternary, Homology modeling & fold prediction, Molecular visualization tools (PyMOL Chimera), Predicting protein structure & stability, Applications in drug target identification",
  },
  {
    title: "Genomics, Transcriptomics & NGS Data Analysis",
    description:
      "Next-Generation Sequencing (NGS) overview, Genome assembly & annotation, RNA-Seq analysis for gene expression, Variant calling & SNP identification, Tools: FASTQC Bowtie HISAT GATK (intro level)",
  },
  {
    title: "Machine Learning & Data Science for Bioinformatics",
    description:
      "Applying ML for biological data, Feature selection from genomic/protein data, Classification models for disease prediction, Clustering for gene expression patterns, AI-driven drug discovery basics",
  },
  {
    title: "Drug Discovery, Docking & Computational Chemistry",
    description:
      "Basics of drug design, Molecular docking principles, Virtual screening & ligand–receptor interactions, ADMET & pharmacokinetic predictions, Using computational tools for drug development",
  },
  {
    title: "Bioinformatics Tools, Programming & Automation",
    description:
      "Python/R for biological data analysis, Working with Biopython & BioConductor, Data cleaning visualization & automation scripts, Shell scripting for pipeline creation, Workflow automation using real tools",
  },
  {
    title: "Capstone Bioinformatics Project & Career Roadmap",
    description:
      "End-to-end project using genomic/protein/NGS data, Research documentation & scientific visualization, GitHub portfolio creation, Resume & LinkedIn optimization for biotech roles, Interview prep for Bioinformatics Analyst Computational Biologist & Research Associate",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
